/// <reference types="vite/client" />

const requireEnv = (name: string): string => {
  const value = import.meta.env[name]
  if (typeof value !== 'string' || value.trim().length === 0) {
    throw new Error(`Missing required environment variable: ${name}`)
  }
  return value
}

const resolveApiUrl = () => {
  if (import.meta.env.DEV) return '/api'
  return requireEnv('VITE_API_URL')
}

const apiUrl = resolveApiUrl()

type AppConfig = {
  apiUrl: string
  geoApiUrl: string
  splashModelUrl?: string
  environment?: string
  isHoldingPageActive: boolean
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig
  }
}

export const config: AppConfig = {
  apiUrl,
  geoApiUrl: requireEnv('VITE_GEO_API_URL'),
  splashModelUrl: import.meta.env.VITE_SPLASH_MODEL_URL,
  environment: import.meta.env.NODE_ENV,
  isHoldingPageActive: false,
}

if (typeof window !== 'undefined') {
  window.__APP_CONFIG__ = config
}

if (import.meta.env.DEV) {
  console.log('DEBUG: App config resolved', {
    apiUrl: config.apiUrl,
    geoApiUrl: config.geoApiUrl,
    environment: config.environment
  })
}
